/* eslint-disable @typescript-eslint/no-explicit-any */
import Image from '../../Image';
import Link from '../../Link';
import { useEffect, useRef, useState } from 'react';
import { useAuth } from '../../../context/auth-context';
import { IMenu } from '../../interfaces';
import Logo from '../images/logo-slogan.svg';
import UserTop from '../images/user-top.svg';
import { useHistory, useLocation } from 'react-router-dom';
import { getSports } from '../../data/sports';

//ball
import BalonFutbol from '../images/sports/futbol/balonNav.svg';
import BalonTenis from '../images/sports/tenis/balonNav.svg';
import BalonPadel from '../images/sports/padel/balonNav.svg';
import BalonBasquetbol from '../images/sports/basquetbol/balonNav.svg';

const Header = (): JSX.Element => {
    const auth = useAuth();
    const isAuthenticated = auth.isLoggedIn;
    const [open, setOpen] = useState<boolean>(false);
    const baseCommon = 'hover:bg-sm-blue-primary-dark hover:text-white px-3 py-2 rounded-md font-medium';
    const classLink = `text-lg text-gray-300 ${baseCommon}`;
    const classLinkMovil = `text-base block text-gray-300  px-3 py-2 rounded-md font-medium`;
    const classLinkInicio = `text-lg text-white font-bold ${baseCommon}`;
    const classLinkInicioMovil = 'text-base block text-white px-3 py-2 rounded-md font-medium';
    const router = useHistory();
    const sport = getSports();
    const ball = sport && sport.ball ? sport.ball : '';
    const wrapperRef = useRef(null);
    const [openSport, setOpenSport] = useState<boolean>(false);
    const pathnameAll = window.location.pathname + useLocation().search;
    const pathname = pathnameAll.split('/');
    const pathnameNew = `/${pathname.slice(2, pathname.length).join('/')}`;
    const [disabledOpenSport, setDisabledOpenSport] = useState<boolean>(false);
    const [nameSport, setNameSport] = useState('');

    const iconBall = {
        tenis: BalonTenis,
        futbol: BalonFutbol,
        padel: BalonPadel,
        basquetbol: BalonBasquetbol,
        profile: null,
    };

    useEffect(() => {
        if (pathname && pathname.length <= 3) {
            setDisabledOpenSport(false);
        } else {
            setDisabledOpenSport(true);
        }
        if (pathname && pathname.length > 0) {
            setNameSport(pathname[1]);
        }
    }, [pathname]);

    useEffect(() => {
        setOpen(false);
        setOpenSport(false);
    }, [ball]);

    useEffect(() => {
        // console.log({ auth });
    }, [auth]);

    useEffect(() => {
        const useOutsideAlerter = (ref) => {
            const handleClickOutside = (event) => {
                if (ref.current && !ref.current.contains(event.target)) {
                    setOpen(false);
                    setOpenSport(false);
                }
            };
            document.addEventListener('mousedown', handleClickOutside);
            return () => {
                document.removeEventListener('mousedown', handleClickOutside);
            };
        };
        if (wrapperRef) {
            useOutsideAlerter(wrapperRef);
        }
    }, [wrapperRef]);

    const handleLogout = async (e: any) => {
        e.preventDefault();
        await auth.logout();
        router.goBack;
    };
    const openLogin = () => {
        router.push({
            pathname: '/login',
        });
    };

    const menu: Array<IMenu> = [
        {
            title: 'ARRIENDA',
            url: `${sport && sport.url ? sport.url : 'futbol'}/arrienda`,
            class: classLink,
            classMovil: classLinkMovil,
            active: true,
        },
        {
            title: 'INTEGRA',
            url: `${sport && sport.url ? sport.url : 'futbol'}/integrar`,
            class: classLink,
            classMovil: classLinkMovil,
            active: true,
        },
        {
            title: 'DESAFÍA',
            url: `${sport && sport.url ? sport.url : 'futbol'}/desafiar`,
            class: classLink,
            classMovil: classLinkMovil,
            active: true,
        },
        {
            title: 'TORNEO',
            url: '#',
            class: classLink,
            classMovil: classLinkMovil,
            active: true,
        },
        {
            title: 'INICIAR SESIÓN',
            url: '/login',
            class: classLinkInicio,
            classMovil: classLinkInicioMovil,
            active: !isAuthenticated,
        },
    ];

    return (
        <nav
            className="z-50 w-full h-20 fixed left-0 top-0 bg-gradient-to-t from-black to-sm-blue-primary "
            ref={wrapperRef}
        >
            <div className="container mx-auto w-full text-white flex-none md:flex">
                <div className="relative flex items-center justify-between h-20 w-full">
                    <div className="flex px-2 md:px-0 items-center justify-center sm:items-stretch sm:justify-start">
                        <div className="shrink-0 flex items-center">
                            <Link to="/">
                                <Image
                                    className="block w-auto cursor-pointer"
                                    imgClassName="h-16"
                                    src={Logo}
                                    alt="SuperMatch - Juega donde y cuando quieras"
                                    height={62}
                                />
                            </Link>{' '}
                            <div
                                onClick={() => {
                                    setOpenSport(!openSport);
                                    setOpen(false);
                                }}
                            >
                                <Image
                                    className={`block w-auto cursor-pointer pl-4 ${nameSport === 'perfil' && 'hidden'}`}
                                    imgClassName="h-16"
                                    src={iconBall[nameSport]}
                                    alt="Deporte"
                                    height={40}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="absolute inset-y-0 right-0 flex items-center pr-2 sm:static sm:inset-auto sm:ml-6 sm:pr-0">
                        <div className="hidden sm:block sm:ml-6">
                            <div className="flex space-x-4 ">
                                {menu.map(
                                    (m) =>
                                        m.active && (
                                            <div className={m.class} key={m.title}>
                                                <Link to={m.url}>{m.title}</Link>
                                            </div>
                                        ),
                                )}
                                {isAuthenticated && open && (
                                    <div className="absolute transition ease-out duration-100 transform  scale-95 z-50 right-0 top-20 w-full origin-top-right rounded-md  shadow-lg md:w-32 text-center cursor-pointer">
                                        <div className="px-2 bg-gradient-to-t from-sm-blue-primary to-black  py-2 rounded-b-md shadow dark-mode:bg-gray-800">
                                            <Link
                                                className="relative block pr-4 py-2 mt-2 text-sm font-semibold bg-transparent rounded-lg dark-mode:bg-transparent dark-mode:hover:bg-gray-600 dark-mode:focus:bg-gray-600 dark-mode:focus:text-white dark-mode:hover:text-white dark-mode:text-gray-200 md:mt-0 hover:text-gray-900 focus:text-gray-900 hover:bg-gray-200 focus:bg-gray-200 focus:outline-none focus:ring"
                                                to="/perfil"
                                                key={'profile-id'}
                                            >
                                                PERFIL
                                                <svg
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    className="absolute right-0  top-0 block h-7 w-7"
                                                    fill="none"
                                                    viewBox="0 0 24 24"
                                                    stroke="currentColor"
                                                >
                                                    <path
                                                        strokeLinecap="round"
                                                        strokeLinejoin="round"
                                                        strokeWidth="2"
                                                        d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"
                                                    />
                                                </svg>
                                            </Link>
                                            <div
                                                className="relative block pr-4 py-2 mt-2 text-sm font-semibold bg-transparent rounded-lg dark-mode:bg-transparent dark-mode:hover:bg-gray-600 dark-mode:focus:bg-gray-600 dark-mode:focus:text-white dark-mode:hover:text-white dark-mode:text-gray-200 md:mt-0 hover:text-gray-900 focus:text-gray-900 hover:bg-gray-200 focus:bg-gray-200 focus:outline-none focus:ring"
                                                onClick={handleLogout}
                                            >
                                                SALIR
                                                <svg
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    className="absolute right-0  top-0 block h-7 w-7"
                                                    fill="none"
                                                    viewBox="0 0 24 24"
                                                    stroke="currentColor"
                                                >
                                                    <path
                                                        strokeLinecap="round"
                                                        strokeLinejoin="round"
                                                        strokeWidth="2"
                                                        d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z"
                                                    />
                                                </svg>
                                            </div>
                                        </div>
                                    </div>
                                )}
                                {openSport && (
                                    <div className="absolute transition ease-out duration-100 transform  scale-95 z-50 left-12 top-20 w-full origin-top-right rounded-md shadow-lg md:w-52 text-right cursor-pointer">
                                        <div className="px-2 bg-gradient-to-t  from-sm-blue-primary to-black   py-2 rounded-b-md shadow dark-mode:bg-gray-800">
                                            <Link
                                                className="relative block px-10 py-2 mt-2 text-sm font-semibold bg-transparent rounded-lg dark-mode:bg-transparent dark-mode:hover:bg-gray-600 dark-mode:focus:bg-gray-600 dark-mode:focus:text-white dark-mode:hover:text-white dark-mode:text-gray-200 md:mt-0 hover:text-gray-900 focus:text-gray-900 hover:bg-gray-200 focus:bg-gray-200 focus:outline-none focus:ring"
                                                to={`${disabledOpenSport ? '/futbol' : '/futbol' + pathnameNew}`}
                                            >
                                                FÚTBOL
                                                <Image
                                                    className="absolute right-0  top-0 block w-auto cursor-pointer pl-4"
                                                    imgClassName="h-16"
                                                    src={BalonFutbol}
                                                    alt="Deporte"
                                                    height={30}
                                                />
                                            </Link>
                                            <Link
                                                className="relative block px-10 py-2 mt-2 text-sm font-semibold bg-transparent rounded-lg dark-mode:bg-transparent dark-mode:hover:bg-gray-600 dark-mode:focus:bg-gray-600 dark-mode:focus:text-white dark-mode:hover:text-white dark-mode:text-gray-200 md:mt-0 hover:text-gray-900 focus:text-gray-900 hover:bg-gray-200 focus:bg-gray-200 focus:outline-none focus:ring"
                                                to={`${disabledOpenSport ? '/padel' : '/padel' + pathnameNew}`}
                                            >
                                                PÁDEL
                                                <Image
                                                    className="absolute right-0  top-0 block w-auto cursor-pointer pl-4"
                                                    imgClassName="h-16"
                                                    src={BalonPadel}
                                                    alt="Deporte"
                                                    height={30}
                                                />
                                            </Link>
                                            <Link
                                                className="relative block px-10 py-2 mt-2 text-sm font-semibold bg-transparent rounded-lg dark-mode:bg-transparent dark-mode:hover:bg-gray-600 dark-mode:focus:bg-gray-600 dark-mode:focus:text-white dark-mode:hover:text-white dark-mode:text-gray-200 md:mt-0 hover:text-gray-900 focus:text-gray-900 hover:bg-gray-200 focus:bg-gray-200 focus:outline-none focus:ring"
                                                to={`#`}
                                            >
                                                TENIS
                                                <Image
                                                    className="absolute opacity-50 right-0  top-0 block w-auto cursor-pointer pl-4"
                                                    imgClassName="h-16"
                                                    src={BalonTenis}
                                                    alt="Deporte"
                                                    height={30}
                                                />
                                            </Link>
                                            <Link
                                                className="relative block px-10 py-2 mt-2 text-sm font-semibold bg-transparent rounded-lg dark-mode:bg-transparent dark-mode:hover:bg-gray-600 dark-mode:focus:bg-gray-600 dark-mode:focus:text-white dark-mode:hover:text-white dark-mode:text-gray-200 md:mt-0 hover:text-gray-900 focus:text-gray-900 hover:bg-gray-200 focus:bg-gray-200 focus:outline-none focus:ring"
                                                to={`#`}
                                            >
                                                BÁSQUETBOL
                                                <Image
                                                    className="absolute opacity-50 right-0  top-0 block w-auto cursor-pointer pl-4"
                                                    imgClassName="h-16"
                                                    src={BalonBasquetbol}
                                                    alt="Deporte"
                                                    height={30}
                                                />
                                            </Link>
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>
                        {!isAuthenticated ? (
                            <button
                                type="button"
                                className="hidden sm:block p-1 rounded-full text-gray-400 hover:text-white focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-gray-800 focus:ring-white"
                                onClick={() => openLogin()}
                            >
                                <Image src={UserTop} alt="Inicia sesion" />
                            </button>
                        ) : (
                            <button
                                type="button"
                                className="hidden sm:block p-1 rounded-full text-gray-400 hover:text-white focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-sm-rent "
                                onClick={() => {
                                    setOpen(!open);
                                    setOpenSport(false);
                                }}
                            >
                                <Image
                                    src={
                                        auth && auth.user && auth.user.photoURL && auth.user.photoURL !== '#'
                                            ? auth.user.photoURL
                                            : UserTop
                                    }
                                    alt="Profile"
                                    imgClassName={`rounded-full  w-14 h-14 ${
                                        auth && auth.user && auth.user.photoURL && auth.user.photoURL !== '#'
                                            ? 'border-2 border-white'
                                            : ''
                                    }`}
                                />
                            </button>
                        )}
                    </div>

                    <div className="absolute inset-y-0 right-0 flex items-center sm:hidden">
                        {/* Mobile menu button*/}
                        <button
                            type="button"
                            className="inline-flex items-center justify-center p-2 rounded-md text-gray-400 hover:text-white hover:bg-sm-blue-primary-dark focus:outline-none focus:ring-2 focus:ring-inset focus:ring-white"
                            onClick={() => setOpen(!open)}
                        >
                            <svg
                                className="block h-6 w-6"
                                xmlns="http://www.w3.org/2000/svg"
                                fill="none"
                                viewBox="0 0 24 24"
                                stroke="currentColor"
                                aria-hidden="true"
                            >
                                <path
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    strokeWidth="2"
                                    d="M4 6h16M4 12h16M4 18h16"
                                />
                            </svg>
                        </button>
                    </div>
                </div>
            </div>

            {/* Mobile menu, show/hide based on menu state. */}
            {open && (
                <div className="sm:hidden bg-sm-blue-primary-dark">
                    <div className="px-2 pt-2 pb-3 space-y-1">
                        {menu.map((m, i) =>
                            m.active ? (
                                <Link to={m.url}>
                                    <div className={m.classMovil} key={`movil-${i}-${m.title}`}>
                                        {m.title}
                                    </div>
                                </Link>
                            ) : (
                                <>
                                    {' '}
                                    <Link to={'/perfil'}>
                                        {' '}
                                        <div className={m.classMovil} key={`movil-${i}-${m.title}`}>
                                            PERFIL{' '}
                                        </div>
                                    </Link>
                                    <div
                                        className={m.classMovil}
                                        key={`movil-salir-${i}-${m.title}`}
                                        onClick={handleLogout}
                                    >
                                        SALIR
                                    </div>
                                </>
                            ),
                        )}
                    </div>
                </div>
            )}

            {/* Mobile menu, show/hide based on menu state. */}
            {openSport && !open && (
                <div className="sm:hidden bg-sm-blue-primary-dark">
                    <div className="px-2 pt-2 pb-3 space-y-1">
                        <Link to={`/futbol${pathnameNew}`}>
                            {' '}
                            <div
                                className={`text-base block text-gray-300  px-3 py-2 rounded-md font-medium`}
                                key={`movil-sport-futbol`}
                            >
                                FÚTBOL{' '}
                            </div>
                        </Link>

                        <Link to={`/padel${pathnameNew}`}>
                            {' '}
                            <div
                                className={`text-base block text-gray-300  px-3 py-2 rounded-md font-medium`}
                                key={`movil-sport-padel`}
                            >
                                PÁDEL
                            </div>
                        </Link>

                        <Link to={`#`}>
                            {' '}
                            <div
                                className={`opacity-50 text-base block text-gray-300  px-3 py-2 rounded-md font-medium`}
                                key={`movil-sport-tenis`}
                            >
                                TENIS{' '}
                            </div>
                        </Link>

                        <Link to={`#`}>
                            {' '}
                            <div
                                className={`opacity-50  text-base block text-gray-300  px-3 py-2 rounded-md font-medium`}
                                key={`movil-sport-basquebol`}
                            >
                                BÁSQUETBOL{' '}
                            </div>
                        </Link>
                    </div>
                </div>
            )}
        </nav>
    );
};

export default Header;
